import React, { createContext, useState } from 'react';

export const CalendarContext = createContext({
    isCoaching: false,
    setIsCoaching: () => {},
    openSession: false,
    setOpenSession: () => {}
});

export default function CalendarProvider({ children }) {
    const [isCoaching, setIsCoaching] = useState(false);
    const [openSession, setOpenSession] = useState(false);

    return (
        <CalendarContext.Provider value={{ isCoaching, setIsCoaching, openSession, setOpenSession }}>{children}</CalendarContext.Provider>
    );
}
